module.exports = __webpack_public_path__ + "vd/assets/audio//lose.6542e86.mp3";